<template>
  <div align="center">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <!-- <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-1)">{{ $t("anonymou_currpage") }}</a> -->
      <img src="../../assets/img/jt.gif" />{{ $t("user") }}
    </div>
    <div>

      <div class="container">
        <form class="form-horizontal">
          <h3> {{ $t("inquiry") }}</h3>
          <div class="form-group">
            <label class="col-sm-2 control-label">{{ $t("normal_inqtype") }}</label>
            <div class="col-sm-10" style="text-align: left">
              <input name="inqtype" type="radio" value="A" checked v-model="Search.AwbBlType"> {{ $t("normal_air") }}
              <!-- <input type="radio" name="inqtype" value="S"  v-model="Search.AwbBlType">{{ $t("normal_sea") }} -->
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label"> {{ $t("normal_inq_etd") }}</label>
            <div class="col-sm-2">
              <!-- <input name="etd" type="text" class="form-control Wdate"  onclick="WdatePicker({startDate:'%y-%M-%d',dateFmt:'yyyy-MM-dd',maxDate:'%y-%M-%d',minDate:'2010-01-01'})" > -->
              <input name="etd" type="text" id="data_WdatePicker" class="form-control Wdate" v-on:click="datePicker('data_WdatePicker')">
            </div>
            <div style="float:left; line-height: 30px;font-weight: bold;">
              --
            </div>
            <div class="col-sm-2">
              <!-- <input name="etd_end" type="text" class="form-control"  onclick="WdatePicker({startDate:'%y-%M-%d',dateFmt:'yyyy-MM-dd',maxDate:'%y-%M-%d',minDate:'2010-01-01'})"> -->

              <input name="etd_end" type="text" class="form-control" id="end_WdatePicker" v-on:click="enddatePicker('end_WdatePicker')">
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label"> {{ $t("normal_word1") }}</label>
            <div class="col-sm-4">

              <select name="codetype" class="form-control" v-model="Search.CodeType">
                <option value="0" selected> {{ $t("select_all") }} </option>
                <option value="1" selected> {{ $t("normal_selectawb") }}</option>
                <option value="2">{{ $t("normal_selectpo") }} </option>
                <option value="3"> {{ $t("normal_selectpart") }} </option>
                <option value="4"> {{ $t("normal_selectcont") }}</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">{{ $t("freight_s") }} </label>
            <div class="col-sm-4">
              <select name="frtTerm" class="form-control" v-model="Search.FrtTerm">
                <option :value="0" selected>{{ $t("select_all") }}</option>
                <option :value="1">PP</option>
                <option :value="2">CC</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label"> {{ $t("anonymou_orgn_code") }}</label>
            <div class="col-sm-4">
              <input name="orgn_code" type="text" class="form-control" v-model="Search.OrgnCode" />
            </div>

          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">{{ $t("anonymou_dest_code") }}</label>
            <div class="col-sm-4">
              <input name="dest_code" type="text" class="form-control" v-model="Search.DestCode" />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">{{ $t("normal_po_inv") }}</label>
            <div class="col-sm-4">
              <input name="inv_no" type="text" class="form-control" v-model="Search.InvNo" />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label"> {{ $t("normal_po_no") }}</label>
            <div class="col-sm-4">
              <input name="po_no" type="text" class="form-control" v-model="Search.PoNo" />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">{{ $t("inputno") }} </label>
            <div class="col-sm-8">
              <textarea class="form-control" name="code" cols="24" rows="4" v-model="Search.HouseNo"></textarea>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label"></label>
            <div class="col-sm-10" style="text-align: left">
              <button type="button" name="Submit" :value="$t('submit')" @click="search()" class="btn btn-primary">
                {{$t('submit')}}
                <span style="width:20px;"></span>
                <img src="../../assets/img/submit.svg" style="width:20px;text-align:right;">
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <input type="reset" name="reset" :value="$t('reset')" @click="reset">
            </div>
          </div>
        </form>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import { GetUserAwbQueryList } from "@/api/UserAwbQuery.js";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
export default {
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
  },
  data () {
    return {
      Search: {
        AwbBlType: "A",
        CodeType: "1",
        EtaDate: "",
        EtdDate: "",
        FrtTerm: 0,
        HouseNo: "",
        PoNo: "",
        InvNo: "",
        DestCode: "",
        OrgnCode: "",
        Page: 1,
        Row: 50,
      },
    };
  },
  mounted () {
    // console.log('来了啊');
    // console.log(this.$store.state.lang)
  },
  methods: {
    radioType (value) {
      // console.log(this.Search.AwbBlType )
      this.Search.AwbBlType = value;
    },
    datePicker: function (elementId) {
      let vueObj = this;
      WdatePicker({
        el: elementId,
        lang: vueObj.$store.state.lang,
        dateFmt: "yyyy-MM-dd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          vueObj.Search.EtaDate = value;
        },
        oncleared: function () {
          vueObj.Search.EtaDate = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
    enddatePicker: function (elementId) {

      let vueObj = this;
      WdatePicker({
        el: elementId,
        lang: vueObj.$store.state.lang,
        dateFmt: "yyyy-MM-dd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          vueObj.Search.EtdDate = value;
        },
        oncleared: function () {
          vueObj.Search.EtdDate = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
    search () {

      this.Search.HouseNo = this.Search.HouseNo.replace(/[\n\r]/g, ",")
      this.$router.push({
        name: "user-awb-query-list",
        query: {
          info: JSON.stringify({
            AwbBlType: this.Search.AwbBlType,
            CodeType: this.Search.CodeType,
            EtaDate: this.Search.EtaDate,
            EtdDate: this.Search.EtdDate,
            FrtTerm: this.Search.FrtTerm,
            HouseNo: this.Search.HouseNo,
            PoNo: this.Search.PoNo,
            InvNo: this.Search.InvNo,
            DestCode: this.Search.DestCode,
            OrgnCode: this.Search.OrgnCode,
            Page: this.Search.Page,
            Row: this.Search.Row,
          }),
        },
      });
    },
    reset () {
      this.Search.AwbBlType = "A";
      this.Search.CodeType = "1";
      this.Search.EtaDate = "";
      this.Search.EtdDate = "";
      this.Search.FrtTerm = 0;
      this.Search.HouseNo = "";
      this.Search.PoNo = "";
      this.Search.InvNo = "";
      this.Search.DestCode = "";
      this.Search.OrgnCode = "";
      this.Search.Page = 1;
      this.Search.Row = 50;
    }
  },
};
</script>